import axios from "axios";
import {getToken} from "./TokenRepository";

const createConfig = () => {
    return {
        headers: {
            'Api-Key': `Bearer ${getToken()}`
        },
    };
}

export const getUsers = async (search, page) => {
    const result = await axios.get(`${process.env.REACT_APP_API_URL}/admin/users?search=${search}&page=${page}`, createConfig());
    return result.data;
}

export const setIsDisabled = async (id, disabled) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/users/setDisabled/${id}`, {
        disabled
    }, createConfig());
    return response.data;
}

export const getUser = async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/users/${id}`, createConfig());
    return response.data;
}

export const setName = async (id, name) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/users/setName/${id}`, {
        name
    }, createConfig());
    return response.data;
}

export const setEmail = async (id, email) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/users/setEmail/${id}`, {
        email
    }, createConfig());
    return response.data;
}

export const createUser = async (name, email) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/users`, {
        name, email
    }, createConfig());
    return response.data;
}

export const updateUserName = async (userName) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/users/updateUserName`, {
        userId: userName.userId,
        serviceTypeId: userName.serviceTypeId,
        userName: userName.userName
    }, createConfig());
    return response.data;
}

export const createUserName = async (userName) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/users/createUserName`, {
        userId: userName.userId,
        serviceTypeId: userName.serviceTypeId,
        userName: userName.userName
    }, createConfig());
    return response.data;
}

export const getServiceTypes = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/searchable/serviceTypes`, createConfig());
    return response.data;
}

export const getServiceUserNames = async (serviceTypeId) => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/searchable/userNames`, {
        ...createConfig(),
        params: {
            serviceTypeId
        }
    });
    return response.data;
}